import { TrailerFieldNames } from '@contracts/order/fields/TrailerInformationFields';
import { PositiveFloatField } from '@src/permitField/PermitFields';

export class TrailerLengthField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerLength;
}

export class TrailerWidthField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerWidth;
}

export class TrailerHeightField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerHeight;
}

export class TrailerWheelbaseLengthField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerWheelbaseLength;
}

export class TrailerDeckHeightField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerDeckHeight;
}

export class TrailerGroundClearanceField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerGroundClearance;
}

export class TrailerKingpinSetbackLengthField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerKingpinSetbackLength;
}

export class TrailerKingpinSettingLengthField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerKingpinSettingLength;
}

export class TrailerEmptyWeightField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerEmptyWeight;
}

export class TrailerRegisteredWeightField extends PositiveFloatField {
  public static fieldName = TrailerFieldNames.TrailerRegisteredWeight;
}
